import httpClient from "../http/http-client";
import { IRegulationApplicabilityResponse } from "./regulation-applicability.model";

export default class RegulationApplicabilityService {
  http;
  constructor() {
    this.http = httpClient
  }

  async getForPeriod(reportPeriodId: string): Promise<IRegulationApplicabilityResponse> {
    return this.http.get(`regulation-applicability/${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}
